import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVolumeXmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 9.49984L21 14.4998M21 9.49984L16 14.4998M4.6 8.99984H5.5012C6.05213 8.99984 6.32759 8.99984 6.58285 8.93116C6.80903 8.87032 7.02275 8.77021 7.21429 8.63542C7.43047 8.48328 7.60681 8.27166 7.95951 7.84843L10.5854 4.69733C11.0211 4.17451 11.2389 3.9131 11.4292 3.8859C11.594 3.86234 11.7597 3.92233 11.8712 4.04592C12 4.18864 12 4.52892 12 5.20948V18.7902C12 19.4708 12 19.811 11.8712 19.9538C11.7597 20.0774 11.594 20.1373 11.4292 20.1138C11.239 20.0866 11.0211 19.8252 10.5854 19.3023L7.95951 16.1512C7.60681 15.728 7.43047 15.5164 7.21429 15.3643C7.02275 15.2295 6.80903 15.1294 6.58285 15.0685C6.32759 14.9998 6.05213 14.9998 5.5012 14.9998H4.6C4.03995 14.9998 3.75992 14.9998 3.54601 14.8908C3.35785 14.795 3.20487 14.642 3.10899 14.4538C3 14.2399 3 13.9599 3 13.3998V10.5998C3 10.0398 3 9.75976 3.10899 9.54585C3.20487 9.35769 3.35785 9.20471 3.54601 9.10883C3.75992 8.99984 4.03995 8.99984 4.6 8.99984Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgVolumeXmark;
